export const getEnvStripUrlId = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "stage":
      return "2033";
    case "develop":
    default:
      return "3911";
  }
};
